import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalFooterFn = /* @__PURE__ */ createRecipe('modalFooter', {}, [])

const modalFooterVariantMap = {}

const modalFooterVariantKeys = Object.keys(modalFooterVariantMap)

export const modalFooter = /* @__PURE__ */ Object.assign(memo(modalFooterFn), {
  __recipe__: true,
  __name__: 'modalFooter',
  raw: (props) => props,
  variantKeys: modalFooterVariantKeys,
  variantMap: modalFooterVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalFooterVariantKeys)
  },
})